export type ValueOf<T> = T[keyof T];
